export default function ScrollProgress({ progress }) {
  return <div className="progress" style={{ width: `${progress}%` }} aria-hidden="true" />;
}
